import { Clock, RefreshCw } from 'lucide-react';
import { useOfflineDataPrep } from '@/hooks/useOfflineDataPrep';
import { Button } from '@/components/ui/button';
import { formatDistanceToNow } from 'date-fns';

export function LastSyncedTimestamp() {
  const { lastSyncTime, prepCriticalData, isPrepping } = useOfflineDataPrep();

  if (!lastSyncTime) return null;

  return (
    <div className="flex items-center gap-2 text-xs text-muted-foreground">
      <Clock className="h-3 w-3" />
      <span>
        Last synced {formatDistanceToNow(lastSyncTime, { addSuffix: true })}
      </span>
      <Button
        size="sm"
        variant="ghost"
        onClick={prepCriticalData}
        disabled={isPrepping}
        className="h-6 px-2"
      >
        <RefreshCw className={`h-3 w-3 ${isPrepping ? 'animate-spin' : ''}`} />
      </Button>
    </div>
  );
}
